import React from "react";
import {
  TouchableOpacity,
  Text,
  View,
  StyleSheet,
  Platform,
} from "react-native";

import AppTheme from "../AppTheme";

export default function ContextMenu({
  context = { x: 0, y: 0 },
  onSnooze = () => {},
  style = {},
  options = [],
}) {
  return (
    <View
      style={[
        styles.container,
        style,
        { left: context.x - 70 },
        {
          transform: [
            {
              translateY: context.y,
            },
          ],
        },
      ]}
    >
      {options.map((option, index) => (
        <TouchableOpacity
          activeOpacity={0.5}
          key={index}
          style={styles.option}
          onPress={() => onSnooze(option.name, index)}
        >
          <Text style={[styles.text, option.style]}>{option.name}</Text>
          <View style={styles.imageRight}>{option.icon}</View>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 140,
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: AppTheme.toggle.bg,
    borderRadius: 4,
    overflow: "visible",
    opacity: 0.9,
    minWidth: 140,
    zIndex: 1000,
  },
  option: {
    height: "100%",
    width: "100%",
    paddingVertical: 6,
    flexDirection: "row",
    paddingHorizontal: 8,
    flex: 1,
    zIndex: 1000,
    height: 30,
  },
  text: {
    color: AppTheme.almostBlack,
    textTransform: "capitalize",
    fontFamily: "Montserrat",
    fontSize: 12,
    lineHeight: 15,
    width: 125,
    letterSpacing: 0.175,
    zIndex: 1000,
  },
  textBold: {
    color: AppTheme.almostBlack,
    textTransform: "capitalize",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    width: 125,
    letterSpacing: 0.175,
    zIndex: 1000,
  },
  imageRight: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    zIndex: 1000,
  },
});
